import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a contemporary fabric armchair, the one-seat sibling of
// sofa-two-seat: same base/back/arm styling at true metric size, front +Z.
const FABRIC = "#8a9aa8";
const FABRIC_DARK = "#758898";
const WALNUT = "#7a5a3a";

export const armchair = defineModel({
  id: "armchair",
  batchId: "modern",
  name: "Armchair",
  tags: ["modern", "interior", "furniture", "seating", "living-room"],
  summary: "A contemporary fabric armchair.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // base frame
      { geometry: new THREE.BoxGeometry(0.85, 0.28, 0.8), color: FABRIC, position: [0, 0.24, 0] },
      // backrest
      { geometry: new THREE.BoxGeometry(0.85, 0.5, 0.2), color: FABRIC, position: [0, 0.6, -0.3] },
      // armrests
      { geometry: new THREE.BoxGeometry(0.16, 0.32, 0.8), color: FABRIC, position: [-0.345, 0.54, 0] },
      { geometry: new THREE.BoxGeometry(0.16, 0.32, 0.8), color: FABRIC, position: [0.345, 0.54, 0] },
      // seat cushion
      { geometry: new THREE.BoxGeometry(0.5, 0.14, 0.56), color: FABRIC_DARK, position: [0, 0.45, 0.05] },
      // back cushion
      { geometry: new THREE.BoxGeometry(0.5, 0.4, 0.12), color: FABRIC_DARK, position: [0, 0.62, -0.18], rotation: [-0.12, 0, 0] },
      // wooden feet
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: WALNUT, position: [-0.36, 0.05, 0.33] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: WALNUT, position: [0.36, 0.05, 0.33] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: WALNUT, position: [-0.36, 0.05, -0.33] },
      { geometry: new THREE.BoxGeometry(0.06, 0.1, 0.06), color: WALNUT, position: [0.36, 0.05, -0.33] },
    ];
  },
  animations: [],
});
